// extracted by mini-css-extract-plugin
module.exports = {"itemsTotal":"paperAnimalIndividual_itemsTotal__OdinV","label":"paperAnimalIndividual_label__26ECh"};